module.exports = __webpack_public_path__ + "static/sylwiawork6-3645c84d8bc39813d2a6c91f5312108d.jpg";